import { useTranslations } from "@/hooks/useTranslations";
import BlogCard from "./BlogCard";
import type { LocalizedPost } from "@/lib/blog";

interface RelatedPostsProps {
  posts: LocalizedPost[];
}

const RelatedPosts = ({ posts }: RelatedPostsProps) => {
  const t = useTranslations();
  if (posts.length === 0) return null;

  return (
    <section className="mt-20">
      <h2 className="text-2xl md:text-3xl font-bold mb-8 gradient-text">{t.blog.related}</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((post) => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>
    </section>
  );
};

export default RelatedPosts;
